const buttonsArray = [
  {
    bool: true,
    name: "isActive",
    _id: "activateUser",
    toolTipColor: "info",
    title: "Activate User",
    icon: "mdi mdi-check-all",
    className: "btn text-black btn-sm btn-primary",
    toolTipText: "Select User and Click to Activate Users"
  },
  {
    bool: false,
    name: "isActive",
    _id: "deActivateUser",
    toolTipColor: "warning",
    title: "De-Activate User",
    icon: "mdi mdi-delete-forever",
    className: "btn text-black btn-sm btn-warning",
    toolTipText: "Select User and Click to De-Activate Users"
  },
  {
    bool: true,
    _id: "activateGeo",
    name: "allowFencing",
    title: "Activate Geo",
    toolTipColor: "success",
    icon: "mdi mdi-map-marker",
    className: "btn text-black btn-sm btn-success",
    toolTipText: "Select User and Click to Activate Geo-Fence"
  },
  {
    bool: false,
    _id: "deActivateGeo",
    name: "allowFencing",
    toolTipColor: "error",
    title: "De-Activate Geo",
    icon: "mdi mdi-map-marker-off",
    className: "btn text-black btn-sm btn-danger",
    toolTipText: "Select User and Click to De-Activate Geo-Fence"
  },
  {
    bool: true,
    _id: "restrict",
    name: "isRestrict",
    title: "Restrict User",
    toolTipColor: "success",
    icon: "mdi mdi-account-remove",
    className: "btn text-black btn-sm btn-blue-green",
    toolTipText: "Select User and Click to Restrict User"
  },
  {
    bool: false,
    _id: "unRestrict",
    name: "isRestrict",
    toolTipColor: "error",
    title: "Un-Restrict User",
    icon: "mdi mdi-account-check",
    className: "btn text-black btn-sm btn-info",
    toolTipText: "Select User and Click to Un-Restrict User"
  },
  {
    bool: true,
    _id: "backup",
    title: "Backup Image",
    toolTipColor: "success",
    name: "isBackupDetectionImage",
    icon: "mdi mdi-backup-restore",
    className: "btn text-black btn-sm btn-green-backup",
    toolTipText: "Select User and Click to Backup Image"
  },
  {
    bool: false,
    _id: "noBackup",
    title: "Stop Backup",
    toolTipColor: "error",
    name: "isBackupDetectionImage",
    icon: "mdi mdi-database-minus",
    toolTipText: "Select User and Click to Stop Backup",
    className: "btn text-black btn-sm btn-green-no-backup"
  }
];

const tableHeader = [
  {
    label: "E-Id",
    place: "left",
    type: "workerId",
    toolTipText: "Click for Id Sorting"
  },
  {
    label: "Shift",
    place: "left",
    type: "shiftCode",
    toolTipText: "Click for Shift Sorting"
  },
  {
    label: "Full Name",
    place: "left",
    type: "workerFullName",
    toolTipText: "Click for Name Sorting"
  },
  {
    label: "Department",
    place: "left",
    type: "workerDepartment",
    toolTipText: "Click for Department Sorting"
  },
  {
    label: "Designation",
    place: "left",
    type: "workerDesignation",
    toolTipText: "Click for Designation Sorting"
  }
];

const toolTipData = [
  {
    id: "loadMore",
    text: "Load More Data"
  },
  {
    id: "isDynamic",
    text: "Search By Static / Dynamic"
  },
  {
    id: "selectedRuleId",
    text: "Select Users and then Select Rules and click Apply."
  },
  {
    id: "applyRule",
    text: "Select Users and then Select Rules and click Apply Button."
  }
];

const topInputToolTipData = [
  {
    id: "Filter",
    text: "Search by User-id, Aadhar-Card, Full Name"
  },
  {
    id: "locationId",
    text: "Select Location to Get the Users"
  },
  {
    id: "activeStatus",
    text: "Change Status to see Respective User."
  },
  {
    id: "exportToExcel",
    text: "Export to Excel."
  },
  {
    id: "userDepartment",
    text: "Select Department."
  }
];

const dynamicInputToolTipData = [
  {
    id: "workerId",
    text: "Search by Employee-Code."
  },
  {
    id: "locationId",
    text: "Select Location to Get the Users."
  },
  {
    id: "exportToExcel",
    text: "Export to Excel."
  }
];

const options = [
  { value: "gender", label: "Gender" },
  // { value: "faceIds", label: "Face Ids" },
  { value: "workerEmail", label: "Email" },
  // { value: "imageIds", label: "Image Ids" },
  // { value: "externalIds", label: "External Ids" },
  { value: "workerPhoneNumber", label: "Phone Number" },
  // { value: "detectionImages", label: "Attendance Images" },
  // { value: "registerFaceImages", label: "Register Face Images" },
  { value: "workerAadharCardNumber", label: "Aadhar Card Number" }
];

export {
  buttonsArray,
  options,
  tableHeader,
  toolTipData,
  topInputToolTipData,
  dynamicInputToolTipData
};
